// @flow
import React, { useState } from 'react'
import { slide as Menu } from 'react-burger-menu';
import { FormattedMessage } from 'react-intl';
import { handleLanguageChange } from '../../utils/LanguageUtils';
import headerBackgroundGradient from '../../ressources/images/background/background.png';
import HeaderBackgroundFlat from '../../ressources/images/background/header_start.inline.svg';
import BILLogo from '../../ressources/images/logo/white-logo.inline.svg';
import LanguagePanel from '../../components/LanguagePanel/LanguagePanel';
import { checkUserDevice, useScrollPosition } from '../../hooks/useWindowDimensions';
import './BILPageHeader.less';

const BILPageHeader = (props) => {

  const { style, children, className, setLoading} = props;
  const isRunningOnMobile = checkUserDevice();
  const [hideOnScroll, setHideOnScroll] = useState(false)

  useScrollPosition(
    ({ currPos }) => {
      const isShow = currPos.y < -100
      if (isShow !== hideOnScroll) setHideOnScroll(isShow)
    },
    [hideOnScroll]
  )

  const componentClassname = className
    ? `page-header ${className}`
    : 'page-header';

  var styles = {
    bmBurgerButton: {
      position: 'fixed',
      width: '36px',
      height: '30px',
      right: '36px',
      top: '36px'
    },
    bmBurgerBars: {
      background: '#373a47'
    },
    bmBurgerBarsHover: {
      background: '#a90000'
    },
    bmCrossButton: {
      height: '24px',
      width: '24px'
    },
    bmCross: {
      background: '#bdc3c7'
    },
    bmMenuWrap: {
      position: 'fixed',
      height: '100%'
    },
    bmMenu: {
      background: 'white',
      padding: '2.5em 1.5em 0',
      fontSize: '1.15em',
      borderRadius: '8px',
      boxShadow: '0 0 16px 0 rgba(0, 0, 0, 0.12)'
    },
    bmMorphShape: {
      fill: '#373a47'
    },
    bmItemList: {
      color: '#b8b7ad',
      padding: '0.8em'
    },
    bmItem: {
      display: 'inline-block'
    },
    bmOverlay: {
      background: 'unset'
    }
  }

  return (
    <header className={componentClassname} style={style}>
      <HeaderBackgroundFlat className={'page-header__background'} />
      <img
        src={headerBackgroundGradient}
        className={
          'page-header__background page-header__background--animated'
        }
        alt="header background"
      />
      <BILLogo className={'page-header__logo'} />
      {children}
      {
        isRunningOnMobile && !hideOnScroll ?
          <Menu right styles={styles}>
            <span className={'burger-menu burger-menu__title'}>
              <FormattedMessage id="language.selection" />
            </span>
            <span className={'burger-menu burger-menu__lang-selection'}>
              <LanguagePanel
                onLanguageChange={(lang) => handleLanguageChange(props, lang, setLoading)}
                isRunningOnMobile={isRunningOnMobile}
                {...props} />
            </span>
          </Menu>
          :
          null
      }
    </header>
  )
};

export default BILPageHeader;
